import React, {useMemo, useCallback } from 'react'
import { SectionTitle } from '../../../components/Dashboard/SectionTitle/SectionTitle';
import { SideMenu } from '../../../components/Dashboard/SideMenu/SideMenu';
import TopBar from '../../../components/Dashboard/TopBar/TopBar';
import {useTranslation} from "react-i18next";
import Button from '../../../components/molecules/Button/Button';
import useTideTable from "../../../components/utility/TideReactTable/useTideTable";
import TideReactTable from "../../../components/utility/TideReactTable/TideReactTable";
import { Link, useNavigate } from 'react-router-dom';
import { paths } from '../../../services/routes/appRoutes';
import './ActiveIngredientsList.scss';
import { activeIngredientsTableSGruops } from '../../../services/models/activeIngredientsUtils';
import { generalDatesFormat } from '../../../services/generalConfig';
import moment from 'moment';

const customProp = "ActiveIngredientsList";

const ActiveIngredientsList = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const activeIngredientsTableColumns = useMemo(() => [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: t('Name'),
            accessor: 'name',
        },
        {
            Header: t('Created'),
            accessor: ingredient => ingredient.createdDate ? moment(ingredient.createdDate).format(generalDatesFormat) : ''
        },
        {
            Header: t('Updated'),
            accessor: ingredient => ingredient.updatedDate ? moment(ingredient.updatedDate).format(generalDatesFormat) : ''
        },
        {
            Header: t("Actions"),
            accessor: brand => 
                    <div className="actions">
                        <Link 
                            to={ paths.mm.activeIngredientsEdit.replace(":id", brand.id) }
                            className="btn-primary"
                        >
                            {t('Edit')}
                        </Link>
                    </div>
        }
    ], [t]);

    const requestFilters = useMemo(() => ({
        sGroups: activeIngredientsTableSGruops
    }), []);

    const requestOptions = useMemo(() => ({ customProp }), []);

    const table = useTideTable({
        entity: 'activeIngredients',
        columns: activeIngredientsTableColumns,
        requestFilters,
        requestOptions
    });

    const handleActiveIngredient = useCallback(()=>navigate(paths.mm.activeIngredientsForm), [navigate]);

    return (
        <div className="ActiveIngredientsList dashboard-container">
            <SideMenu />
            <div className='right-content'>
                <TopBar />
                <div className='main-content'>
                    <SectionTitle>{t('Active-ingredients')}</SectionTitle>

                    <div className='row'>
                        <div className='col d-flex justify-content-end align-items-center gap-3'>
                            <Button 
                                className={'submit btnNewProducer'} 
                                type='button' 
                                onClick={handleActiveIngredient}
                                id="add-new-active-ingredient"
                            >
                                + {t("Add-new-active-ingredient")}
                            </Button>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="">
                            <TideReactTable 
                                {...table.tableProps} 
                                className="active-ingredients-table"
                            />
                        </div>
                    </div>   
                </div>
            </div>
        </div>
    );
}

export default ActiveIngredientsList;